import * as React from 'react';

import {
  Props,
} from 'one-ui';

/**
 * User Navigation displayed to top right of the header
 * @children is passed in props contains the usernavigation Items
 */
export const UserNavigation: any = (
  props: Props
) => {
  const {
    children
  } = props;
  return (
    <div className="user-navigation">
    <ul className="user-navigation__list">
        {children}
    </ul>
    </div>
  )
};
